'use client';

import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { subscribeLastReadStatus } from 'services/communication';
import { StorageServices } from 'services/storage';

type NewMessageContextType = {
  isNewMessage: boolean;
  refreshStatus: () => void;
};

const NewMessageContext = createContext<NewMessageContextType>({
  isNewMessage: false,
  refreshStatus: () => {}
});

const storage = new StorageServices();

export const NewMessageProvider = ({ children }: { children: React.ReactNode }) => {
  const [isNewMessage, setIsNewMessage] = useState<boolean>(false);

  const refreshStatus = useCallback(() => setIsNewMessage(false), []);

  useEffect(() => {
    if (!storage.getAccessToken()) return;

    const unsubscribe = subscribeLastReadStatus((data) => {
      if (data) {
        setIsNewMessage(!data.isRead);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <NewMessageContext.Provider value={{ isNewMessage, refreshStatus }}>
      {children}
    </NewMessageContext.Provider>
  );
};

export const useNewMessage = () => useContext(NewMessageContext);
